import React from 'react';
import { LuStore } from 'react-icons/lu';
import Badge from '../../ui/Badge';

const StoresFoundBadge = ({ found, visits }) => (
  <Badge size="sm" tone={visits && found === visits ? 'green' : 'slate'} icon={LuStore}>
    {found}/{visits}
  </Badge>
);

export default StoresFoundBadge;
